
import axios from '../../config/axiosConfig';
import { GET_BANK_RECEIPT_TRANSACTIONS, BANK_RECEIPT_TRANSACTION_REQUEST, BANK_RECEIPT_TRANSACTION_REQUEST_FAILURE, GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_RECEIPT_TRANSACTIONS, GET_BANK_NAME_BANK_RECEIPT_TRANSACTIONS } from '../types';

export const getBankReceiptTransactions = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BANK_RECEIPT_TRANSACTION_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };
            axios.get('/bank-receipt-transaction/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BANK_RECEIPT_TRANSACTIONS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BANK_RECEIPT_TRANSACTION_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_RECEIPT_TRANSACTION_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const getAllAccountIdWiseConsigneeBankReceiptTransactions = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };

      return axios.get("/bank-receipt-transaction/get-account-id-wise-consignee", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_RECEIPT_TRANSACTIONS, payload: response?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_TRANSACTION_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getAllBankNameBankReceiptTransactions = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };

      return axios.get("/bank-receipt-transaction/get-bank-names", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANK_NAME_BANK_RECEIPT_TRANSACTIONS, payload: response?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_TRANSACTION_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};
